import React from 'react';
import AILoadingAnimation from './AILoadingAnimation';

const DescriptionLoadingSkeleton = () => {
  const messages = ['Processing...', 'Analyzing...', 'Generating...', 'Finalizing...'];

  return (
    <AILoadingAnimation
      messages={messages}
      className="description-loading-container"
      containerSx={{
        border: 'none',
        borderRadius: 0,
        background: 'transparent',
      }}
    />
  );
};

export default DescriptionLoadingSkeleton;
